// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-icon-icon-svg-eulhr{fill:currentColor}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svg": "components-icon-icon-svg-eulhr"
};
module.exports = ___CSS_LOADER_EXPORT___;
